<div class="topbar creator-top-bar clearfix" [class.hidden]="topBarIsHidden" *ngIf="!isSubscriber">
  <div class="topbar-right">
    <div class="top-bar-title creator-top-bar-title">
      <div class="left-app-logo" *ngIf="sideMenuIsHidden; else menuButton">
        <img class="cplogo" [src]="srclogo" [routerLink]="['/']" routerLinkActive="router-link-active"/>
      </div>
      <ng-template #menuButton>
        <div class="leftpanel-menu-button" (click)="app.onMenuButtonClick()">
          <i class="fas pi pi-bars"></i>
        </div>
      </ng-template>
      <div
        class="context-breadcrumbs"
        *ngFor="let context of topBarNavigationContext; let i = index"
      >
        <label class="context-label" for="context-name">{{ context.label }} </label>
        <a
          [routerLink]="context.link"
          routerLinkActive="router-link-active"
          name="context-name"
          class="context-name"
        >
          <span>{{ context.name }}</span>
          <i *ngIf="topBarNavigationContext.length - 1 !== i" class="pi pi-chevron-right"></i>
        </a>
      </div>
    </div>
    <div id="rightpanel-menu-button" *ngIf="showButton">
      <button pButton class="p-button-hollow username" label={{buttonLabel}} (click)="ButtonOnClick()"></button> 
    </div>

    <div id="rightpanel-menu-button" *ngIf="user?.id">
      <strong style="margin-right: 25px; color: black; cursor: pointer;" [routerLink]="['/']" *ngIf="topBarData !=='Console'">Home</strong>
      <strong style="width: max-content; color: black;" class="username" *ngIf="topBarData ==='Console'">Hello, {{ user?.username }}!</strong>
      <img
        #overlayTarget
        (click)="creatorop.show($event, overlayTarget)"
        class="profile-pic"
        [src]="(user?.profilePhoto.sizes)[0]?.url"
        style="margin-right: 5px; cursor: pointer;"
      />
      <p-overlayPanel #creatorop>
        <ul>
          
          <li *ngIf="prevUser" (click)="userService.endImpersonation()" class="link">
            End Impersonation
          </li>
          <li class="link">
              <p>{{user.name}}</p>
              <p>@{{user.username}}</p>
          </li>
          <div class="separator"></div>
          <li [routerLink]="['/setting']"class="link" (click)="creatorop.hide()">Account Settings</li>
          <div class="separator"></div>
          <li *ngIf="!prevUser" (click)="logout()" class="link red">Logout</li>
          <div class="clearfix"></div>
        </ul>
      </p-overlayPanel>
    </div>
  </div>
</div>

<div class="topbar default-top-bar clearfix" [class.hidden]="topBarIsHidden" *ngIf="isSubscriber">
  <div class="topbar-right">
    <div class="top-bar-title default-top-bar-title">
      <div class="left-app-logo" *ngIf="sideMenuIsHidden; else menuButton">
        <div class="logo" [routerLink]="['/']" routerLinkActive="router-link-active"></div>
      </div>
      <ng-template #menuButton>
        <div class="leftpanel-menu-button" (click)="app.onMenuButtonClick()">
          <i class="fas pi pi-bars"></i>
        </div>
      </ng-template>
      <div
        class="context-breadcrumbs"
        *ngFor="let context of topBarNavigationContext; let i = index"
      >
        <label class="context-label" for="context-name">{{ context.label }} </label>
        <a
          [routerLink]="context.link"
          routerLinkActive="router-link-active"
          name="context-name"
          class="context-name"
        >
          <span>{{ context.name }}</span>
          <i *ngIf="topBarNavigationContext.length - 1 !== i" class="pi pi-chevron-right"></i>
        </a>
      </div>
    </div>
    <div id="rightpanel-menu-button" *ngIf="user?.id">
      <span class="username">Hello, {{ user?.username }}!</span>
      <img
        #overlayTarget
        (click)="op.show($event, overlayTarget)"
        class="profile-pic"
        [src]="(user?.profilePhoto.sizes)[0]?.url"
      />
      <p-overlayPanel #op>
        <ul>
          
          <li *ngIf="prevUser" (click)="userService.endImpersonation()" class="link">
            End Impersonation
          </li>
          <li class="link">
              <p>{{user.name}}</p>
              <p>@{{user.username}}</p>
          </li>
          <div class="separator"></div>
          <li [routerLink]="['/setting']"class="link" (click)="op.hide()">Account Settings</li>
          <li [routerLink]="['/editprofile']" class="link" (click)="op.hide()">Edit Profile</li>
          <div class="separator"></div>
          <li [routerLink]="['/faqs']" class="link" (click)="op.hide()">Exhibit Hall FAQs</li>
          <li class="link" (click)="op.hide()">
            <a href="https://drive.google.com/drive/folders/1hjh_tNnXoIVLUb_sqVdU0mU_0e-TMYRU?usp=drive_link" target="_blank" style="color: inherit; text-decoration: none;">Help & Guides</a>
          </li>
          <li
            class="input-container p-col-12"
            *ngIf="userService?.userPreferences?.backstageTutorialMode"
          >
            <div class="link input-cell ">
              <label>TUTORIAL MODE</label>
              <p-inputSwitch
                [(ngModel)]="userService.userPreferences.backstageTutorialMode.enabled"
                (ngModelChange)="enableTutorialMode($event)"
                name="tutorial-mode"
              ></p-inputSwitch>
            </div>
          </li>
          <div class="separator"></div>
          <li *ngIf="!prevUser" (click)="logout()" class="link red">Logout</li>
          <div class="clearfix"></div>
        </ul>
      </p-overlayPanel>
    </div>
  </div>
</div>
